//import TextAreaComponent from "@/pcomponents/common/crud/write/textarea";
import strFunc from '@/lib/lyg/string';
import { useRef, useEffect } from 'react';
function TextAreaComponent(props:any){
   let myProps={
    name:"",
    value:"",
    onChange:(e:any)=>{},
    onClick:(e:any)=>{},
    onBlur:(e:any)=>{},
    class_name:"row-input",
    input_ref: null,
    placeholder:"",
    style:{},
    height:26,
    scroll_add_height:2,
    autoComplete:"off",
    is_auto_height:true,
    is_read_only:false,
    title:"",
    ...props
  };
  if(myProps.value==undefined||myProps.value==null){
    myProps.value="";
  }
  myProps.value=strFunc.decodeHtmlAll(myProps.value);
  let text_area_style:any={
    "width":"100%",
    "resize":"none",
    "lineHeight":"20px",
    overflow:"hidden",
    padding:"1px",
    ...myProps.style,
    height:myProps.height+"px",
  };

  const textarea_ref=useRef<any>(null);

  useEffect(()=>{
    if(textarea_ref.current){
      textarea_ref.current.style.height=myProps.height+"px";
    }
    set_auto_height_textarea();
  },[myProps.value,myProps.is_auto_height]);

  const set_auto_height_textarea=()=>{
    if(myProps.is_auto_height!=true){
      return false;
    }
    if(textarea_ref.current){
      let tmp_area_h=myProps.height;
      let line_cnt=myProps.value.split("\n").length
      let basic_height=parseInt(strFunc.getNumber2(text_area_style.lineHeight))*(line_cnt);
      textarea_ref.current.style.height=basic_height+"px";
      if(textarea_ref.current.scrollHeight>myProps.height){
        tmp_area_h = (textarea_ref.current.scrollHeight+myProps.scroll_add_height);
      }
      textarea_ref.current.style.height=tmp_area_h+"px";
    }
  };
  if(textarea_ref.current&&myProps.input_ref){
    myProps.input_ref.current=textarea_ref.current;
  }

  return (
  <textarea
    className={myProps.class_name}
    name={myProps.name}
    value={myProps.value}
    placeholder={myProps.placeholder}
    style={text_area_style}
    autoComplete={myProps.autoComplete}
    readOnly={myProps.is_read_only}
    title={myProps.title}
    ref={textarea_ref}
    onChange={(e: any) => {
      myProps.onChange(e);
    }}
    onClick={(e: any) => {
      myProps.onClick(e);
    }}
    onBlur={(e: any) => {
      myProps.onBlur(e);
    }}
  ></textarea>
  );
};
export default TextAreaComponent;